import { InlineAlert } from '@modusign/design-system';

function BatchPermissionGrantInlineAlert() {
  return (
    <InlineAlert
      sx={{
        background: 'transparent',
        border: 'none',
        p: 0,
        mb: 4,
      }}
      variant="informational"
    >
      기존 공유 설정은 모두 제거됩니다.
    </InlineAlert>
  );
}

export default BatchPermissionGrantInlineAlert;
